import { ClientsFeedbackSection, PopularPlacesSection } from '../Welcome/fragments';
import { StyledAboutContainer } from './styled';

export const About = () => (
  <StyledAboutContainer>
    <PopularPlacesSection about />
    {/* todo open after release
    <ImagesContainer>
      <img className="people" src={Images.peoples} alt="img" />
      <img className="sun" src={Images.sun} alt="img" />
    </ImagesContainer>
    <WithUs />
    <TeamWord>
      <img src={Images.teamWord} alt="teamWord" />
    </TeamWord> */}
    <ClientsFeedbackSection />
  </StyledAboutContainer>
);
